export const KES_TIME_ZONE = 'America/Chicago';

export function money(v: number): string {
  return v.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: v % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
}
export function localDateTime(utc: string | null | undefined, tz = KES_TIME_ZONE): string {
  if (!utc) return '—';
  return new Date(utc).toLocaleString('en-US', { timeZone: tz, month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
}
export function localDate(utc: string | null | undefined, tz = KES_TIME_ZONE): string {
  if (!utc) return '—';
  return new Date(utc).toLocaleDateString('en-US', { timeZone: tz, month: 'short', day: 'numeric', year: 'numeric' });
}
export function localTime(utc: string | null | undefined, tz = KES_TIME_ZONE): string {
  if (!utc) return '—';
  return new Date(utc).toLocaleTimeString('en-US', { timeZone: tz, hour: 'numeric', minute: '2-digit' });
}
/** yyyy-MM-dd DateOnly -> "Sep 21, 2026" without timezone shifting. */
export function dateOnly(d: string | null | undefined): string {
  if (!d) return '—';
  const [y, m, day] = d.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, day)).toLocaleDateString('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' });
}
export function timeAgo(utc: string | null | undefined, now = Date.now()): string {
  if (!utc) return 'never';
  const s = Math.max(0, Math.round((now - new Date(utc).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)}m ago`;
  if (s < 86400) return `${Math.round(s / 3600)}h ago`;
  return `${Math.round(s / 86400)}d ago`;
}
export function initials(name: string): string {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]!.toUpperCase()).join('');
}
export function shortName(name: string): string {
  const parts = name.trim().split(/\s+/);
  return parts.length > 1 ? `${parts[0]} ${parts[parts.length - 1]![0]}.` : name;
}
export function titleCase(s: string): string { return s ? s[0]!.toUpperCase() + s.slice(1).toLowerCase() : s; }
